
(function () {
  'use strict';

  function initCSFFooter(root) {
    if (!root || root.dataset.csfFooterReady === 'true') return;

    root.dataset.csfFooterReady = 'true';

    var successMessage = root.querySelector('[data-csf-newsletter-success]');

    if (successMessage) {
      window.requestAnimationFrame(function () {
        successMessage.focus({ preventScroll: true });
      });
    }
  }

  function initAllCSFFooters(scope) {
    if (scope && scope.matches && scope.matches('[data-csf-footer]')) {
      initCSFFooter(scope);
    }

    if (scope && scope.querySelectorAll) {
      scope.querySelectorAll('[data-csf-footer]').forEach(initCSFFooter);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCSFFooters(document);
    });
  } else {
    initAllCSFFooters(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllCSFFooters(event.target);
  });
})();
